import { Delete } from "@mui/icons-material";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import { formatDateString } from "../../actprep-ui/utils/formatting";

export default function ProgramAssignmentList({ assignments, onDelete }) {
  return (
    <List>
      {assignments.map((relation) => {
        const { uuid, start_date, program, end_date } = relation;
        let secondary = formatDateString(start_date);
        if (end_date) {
          secondary += ` - End: ${formatDateString(end_date)}`;
        }
        return (
          <ListItem
            key={uuid}
            divider
            secondaryAction={
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => onDelete(uuid)}
              >
                <Delete />
              </IconButton>
            }
          >
            <ListItemText primary={program.title} secondary={secondary} />
          </ListItem>
        );
      })}
    </List>
  );
}
